import React from 'react';
// import {MUTypography} from 'basic-components';
import MUTypography from '../../../../../ui/MUTypography';
import _ from 'lodash';
import localApiRichContent from './localApiRichContent';

const renderInlineParts = (parts) => (
  parts.map((part, index) => {
    if (part.link) {
      return (
        <a
          key={index}
          href={part.link}
          target="_blank"
          rel="noreferrer"
          style={{ fontWeight: part.bold ? 600 : 400 }}
        >
          {part.text}
        </a>
      );
    }

    if (part.bold) {
      return <strong key={index} style={{ fontWeight: 600 }}>{part.text}</strong>;
    }

    return <React.Fragment key={index}>{part.text}</React.Fragment>;
  })
);

const renderListItems = (items, nested = false) => (
  <ul
    style={{
      marginTop: nested ? 6 : 0,
      marginBottom: nested ? 0 : 16,
      ...(nested ? { paddingLeft: 0, listStylePosition: 'inside' } : {}),
      fontFamily: 'Gilroy-Light',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '22.4px',
      color: 'rgb(51, 51, 51)'
    }}
  >
    {items.map((item, itemIndex) => (
      <li key={itemIndex} style={{ marginBottom: nested ? 4 : 6 }}>
        {item.parts ? renderInlineParts(item.parts) : item.text}
        {item.subItems && item.subItems.length ? renderListItems(item.subItems, true) : null}
      </li>
    ))}
  </ul>
);

const renderContentBlocks = (blocks, classes) => (
  blocks.map((block, index) => {
    if (block.type === 'list') {
      return <React.Fragment key={index}>{renderListItems(block.items)}</React.Fragment>;
    }

    if (block.type === 'json') {
      return (
        <pre
          key={index}
          style={{
            whiteSpace: 'pre-wrap',
            background: '#f7f7f7',
            padding: 12,
            borderRadius: 8,
            marginBottom: 16,
            overflowX: 'auto'
          }}
        >
          {block.value}
        </pre>
      );
    }

    if (block.type === 'h') {
      return (
        <MUTypography
          key={index}
          variant='subheading'
          paragraph={true}
          className={classes.sectionHeading}
        >
          {block.parts ? renderInlineParts(block.parts) : block.text}
        </MUTypography>
      );
    }

    return (
      <MUTypography
        key={index}
        variant='display1'
        paragraph={true}
        className = {classes.paragraph}
      >
        {block.parts ? renderInlineParts(block.parts) : block.text}
      </MUTypography>
    );
  })
);

const ApiInfo = (props) => {
  const selectedProduct = _.find(
    props.productList,
    product => product.id === props.infoContent.content
  ) || {};

  const localContent = localApiRichContent[selectedProduct.id] || null;

  return (
    <div>
      <MUTypography variant='title' paragraph={true} className = {props.classes.h5}>
        {localContent && localContent.title ? localContent.title : selectedProduct.name}
      </MUTypography>

      {localContent ? (
        <div>
          {localContent.image ? (
            <img
              src={localContent.image}
              alt={localContent.imageAlt || selectedProduct.name}
              style={{ maxWidth: '100%', borderRadius: 8, marginBottom: 16 }}
            />
          ) : null}

          {localContent.blocks
            ? renderContentBlocks(localContent.blocks, props.classes)
            : localContent.paragraphs.map((paragraph, index) => (
              <MUTypography
                key={index}
                variant='display1'
                paragraph={true}
                className = {props.classes.paragraph}
              >
                {paragraph}
              </MUTypography>
            ))}
        </div>
      ) : (
        <MUTypography variant='display1' paragraph={true} className = {props.classes.paragraph}>
          {selectedProduct.description}
        </MUTypography>
      )}
    </div>
  );
};

export default ApiInfo;
